/** デモ用に生成したレポート UUID の接頭辞。実在しないので、リンク先を一覧へ逃がす判定に使う */
export const demoReportUuidPrefix = 'demo-report-'

/**
 * 詳細（L2）の「該当レポート」リンクの遷移先
 *
 * デモ用の UUID はレポートとして実在せず、詳細画面を開くと「見つかりません」になる。
 * そのため実在しない UUID の行はレポート一覧へ向ける。
 */
export const buildReportHref = (reportUuid: string): string =>
  reportUuid.startsWith(demoReportUuidPrefix)
    ? '/reports'
    : `/reports/${reportUuid}`
